<p-toast [baseZIndex]="2000">
  <ng-template let-message pTemplate="message">
    @if (message.severity == 'info') {
      <svg-icon key="info"></svg-icon>
    }
    @if (message.severity == 'warn') {
      <svg-icon key="alert"></svg-icon>
    }
    @if (message.severity == 'success') {
      <svg-icon key="check-circled"></svg-icon>
    }
    @if (message.severity == 'error') {
      <svg-icon key="warning"></svg-icon>
    }

    <div class="toast-content" [attr.data-test]="message.id">
      @if (message?.summary?.length > 0) {
        <div class="toast-title">{{message.summary}}</div>
      }
      @if (message?.detail?.length > 0) {
        <div class="toast-message">{{message.detail}}</div>
      }
    </div>
  </ng-template>
</p-toast>

<!-- template toast per update -->
<p-toast [baseZIndex]="2000" key="update" (onClose)="onReject('update')">
  <ng-template let-message pTemplate="message">
    @if (message.severity == 'info') {
      <svg-icon key="info"></svg-icon>
    }
    @if (message.severity == 'warn') {
      <svg-icon key="alert"></svg-icon>
    }
    @if (message.severity == 'success') {
      <svg-icon key="check-circled"></svg-icon>
    }
    @if (message.severity == 'error') {
      <svg-icon key="warning"></svg-icon>
    }

    <div class="toast-content" [attr.data-test]="message.id">
      @if (message?.summary?.length > 0) {
        <div class="toast-title">{{message.summary}}</div>
      }
      @if (message?.detail?.length > 0) {
        <div class="toast-message">{{message.detail}}</div>
      }
      <div class="commands-container">
        <nts-filled-button
          [title]="message.data.confirmLabel"
          [label]="message.data.confirmLabel"
          [icon]="message.data.confirmIcon"
          [type]="3"
          (onClicked)="onConfirmUpdate(message, 'update')"></nts-filled-button>
      </div>
    </div>
  </ng-template>
</p-toast>

<p-toast [baseZIndex]="2000" key="with-commands-top-center" position="top-center"
  (onClose)="onReject('with-commands-top-center')">
  <ng-template let-message pTemplate="message">
    @if (message.severity == 'info') {
      <svg-icon key="info"></svg-icon>
    }
    @if (message.severity == 'warn') {
      <svg-icon key="alert"></svg-icon>
    }
    @if (message.severity == 'success') {
      <svg-icon key="check-circled"></svg-icon>
    }
    @if (message.severity == 'error') {
      <svg-icon key="warning"></svg-icon>
    }

    <div class="toast-content" [attr.data-test]="message.id">
      @if (message?.data?.summary$ || message?.summary?.length > 0) {
        <div class="toast-title">
          {{ ($safeNavigationMigration(message?.data?.summary$) | async) || message.summary  }}
        </div>
      }
      @if (message?.data?.detail$ || message?.detail?.length > 0) {
        <div class="toast-message">
          {{ ($safeNavigationMigration(message?.data?.detail$) | async) || message.detail }}
        </div>
      }
      <div class="commands-container">
        @for (cmd of $any(message.data.commands$ | async); track cmd) {
          <nts-filled-button
            [title]="cmd.command.tooltip$ | async"
            [icon]="cmd.command.iconClass$ | async"
            [type]="cmd.type"
            (onClicked)="onCommandExecute(message, 'with-commands-top-center', cmd)"
            [label]="cmd.command.displayName$ | async">
          </nts-filled-button>
        }
      </div>
    </div>
  </ng-template>
</p-toast>
<!-- fine template toast per update -->